import Vue from 'vue'
import { API_URL } from '../../api'
import TransactionRequestsFilter from '../../filters/TransactionRequestsFilter';

const state = {
    transactionRequestCreate: {
        createdTransactionRequest: null,
        creatingTransactionRequest: false,
        createTransactionRequestStatus: null
    },
    transactionRequestUpdate: {
        updatedTransactionRequest: null,
        updatingTransactionRequest: false,
        updateTransactionRequestStatus: null
    },
    transactionRequestDelete: {
        deletingTransactionRequest: false,
        deleteTransactionRequestStatus: null
    },
    transactionRequestSearch: {
        transactionRequestsCount: null,
        transactionRequests: [],
        searchingTransactionRequests: false,
        searchtransactionRequestStatus: null
    },
}

const mutations = {
    ['SET_TRANSACTION_REQUEST_CREATE'](state, change) {
        state.transactionRequestCreate = { ...state.transactionRequestCreate, ...change };
    },
    ['SET_TRANSACTION_REQUEST_UPDATE'](state, change) {
        state.transactionRequestUpdate = { ...state.transactionRequestUpdate, ...change };
    },
    ['SET_TRANSACTION_REQUEST_DELETE'](state, change) {
        state.transactionRequestDelete = { ...state.transactionRequestDelete, ...change };
    },
    ['SET_TRANSACTION_REQUEST_SEARCH'](state, change) {
        state.transactionRequestSearch = { ...state.transactionRequestSearch, ...change };
    },
}

const actions = {
    createTransactionRequest: ({ commit }, payload) => {
        commit('SET_TRANSACTION_REQUEST_CREATE', { createTransactionRequestStatus: null, createdTransactionRequest: null, creatingTransactionRequest: true })
        return Vue.http.post(API_URL + '/requests/transaction/create', payload).then(response => {
            commit('SET_TRANSACTION_REQUEST_CREATE', { createTransactionRequestStatus: 'success', createdTransactionRequest: response.body.results.transactionRequest });
        }).catch(response => {
            commit('SET_TRANSACTION_REQUEST_CREATE', { createTransactionRequestStatus: 'failed' });
        }).finally(() => {
            commit('SET_TRANSACTION_REQUEST_CREATE', { creatingTransactionRequest: false });
        });
    },

    updateTransactionRequest: ({ commit }, payload) => {
        commit('SET_TRANSACTION_REQUEST_UPDATE', { updateTransactionRequestStatus: null, updatedTransactionRequest: null, updatingTransactionRequest: true })
        return Vue.http.post(API_URL + '/requests/transaction/update/' + payload.id, payload)
            .then(response => {
                commit('SET_TRANSACTION_REQUEST_UPDATE', { updateTransactionRequestStatus: 'success', updatedTransactionRequest: response.body.results.transactionRequest });
            })
            .catch(response => {
                commit('SET_TRANSACTION_REQUEST_UPDATE', { updateTransactionRequestStatus: 'failed' });
            })
            .finally(() => {
                commit('SET_TRANSACTION_REQUEST_UPDATE', { updatingTransactionRequest: false });
            })
    },

    updateTransactionRequestStatus: ({ commit }, payload) => {
        commit('SET_TRANSACTION_REQUEST_UPDATE', { updateTransactionRequestStatus: null, updatedTransactionRequest: null, updatingTransactionRequest: true })
        return Vue.http.post(API_URL + '/requests/transaction/status/update/' + payload.id, payload)
            .then(response => {
                commit('SET_TRANSACTION_REQUEST_UPDATE', { updateTransactionRequestStatus: 'success', updatedTransactionRequest: response.body.results.transactionRequest });
            })
            .catch(response => {
                commit('SET_TRANSACTION_REQUEST_UPDATE', { updateTransactionRequestStatus: 'failed' });
            })
            .finally(() => {
                commit('SET_TRANSACTION_REQUEST_UPDATE', { updatingTransactionRequest: false });
            })
    },

    deleteTransactionRequest: ({ commit }, id) => {
        commit('SET_TRANSACTION_REQUEST_DELETE', { deleteTransactionRequestStatus: null, deletedTransactionRequest: null, deletingTransactionRequest: true })
        return Vue.http.delete(API_URL + '/requests/transaction/delete/' + id).then(response => {
            commit('SET_TRANSACTION_REQUEST_DELETE', { deleteTransactionRequestStatus: 'success' });
        }).catch(response => {
            commit('SET_TRANSACTION_REQUEST_DELETE', { deleteTransactionRequestStatus: 'failed' });
        }).finally(() => {
            commit('SET_TRANSACTION_REQUEST_DELETE', { deletingTransactionRequest: false });
        })
    },

    searchTransactionRequests: ({ commit }, payload = { filter: TransactionRequestsFilter(), resultMode: 'default' }) => {
        commit('SET_TRANSACTION_REQUEST_SEARCH', { searchtransactionRequestStatus: null, searchtransactionRequest: null, searchingTransactionRequests: true })
        let filerJson = JSON.stringify(payload.filter);
        switch (payload.resultMode) {
            case 'count': payload.resultMode = 1; break;
            case 'paginated': payload.resultMode = 2; break;
            case 'paginatedPersist': payload.resultMode = 21; break;
            default: payload.resultMode = 0; break;
        }
        var params = '?query=' + encodeURIComponent(filerJson) + '&result_mode=' + payload.resultMode;
        return Vue.http.get(API_URL + '/requests/transaction' + params).then(response => {
            if (payload.resultMode == 1) {
                commit('SET_TRANSACTION_REQUEST_SEARCH', { searchtransactionRequestStatus: 'success', transactionRequestsCount: response.body.results.transactionRequests });

            } else if (payload.resultMode == 2) {
                commit('SET_TRANSACTION_REQUEST_SEARCH', { searchtransactionRequestStatus: 'success', transactionRequestsPaginated: response.body.results.transactionRequests });

            } else {
                commit('SET_TRANSACTION_REQUEST_SEARCH', { searchtransactionRequestStatus: 'success', transactionRequests: response.body.results.transactionRequests });
            }
        }).catch(response => {
            commit('SET_TRANSACTION_REQUEST_SEARCH', { searchtransactionRequestStatus: 'failed' });
        }).finally(() => {
            commit('SET_TRANSACTION_REQUEST_SEARCH', { searchingTransactionRequests: false });
        })
    },
}

export default {
    state, mutations, actions
} 



// WEBPACK FOOTER //
// ./resources/js/store/modules/transactionRequestStore.js